export default __webpack_public_path__ + "static/vid1-b18e6f55c85fa8f7d3c2bb2de03a8133.mp4";